const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
]
const getLocalTimeString = (timeValue) => {
  let month = months[timeValue.getMonth()]
  let date = timeValue.getDate()
  let year = timeValue.getFullYear()
  let hours = (timeValue.getHours() < 10 ? '0' : '') + timeValue.getHours()
  let ind = null
  if (hours < 12) {
    ind = 'AM'
  }
  if (hours >= 12) {
    ind = 'PM'
    if (hours > 12) {
      hours = hours - 12
    }
  }
  let minutes = (timeValue.getMinutes() < 10 ? '0' : '') + timeValue.getMinutes()
  return month + ' ' + date + ', ' + year + '. ' +
  hours + ':' + minutes + ' ' + ind
}

export default getLocalTimeString
